import {Link } from "react-router-dom";

export default function Footer() {
//TODO fix footer 100% or 100vw
  return (
    <div className="footer">
      <div className="footer_container">
        <ul>
          <li>サイトマップ</li>
          <li>
          <Link to ="/policy" >サイトポリシー</Link>
          </li>
          <li>
            <Link to="/contact">お問い合わせ</Link>
          </li>
        </ul>
        <div className="footer_container_sideContainer">
          <h5>食品配送のご要望・その他お問い合わせは・・</h5>
          <h4>06-4306-0512</h4>
        </div>
      </div>
      <h6>Copyright &#169; Daikoku Foods Co., Ltd. All Rights Reserved.</h6>
    </div>
  );
}
